import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  name: validator('presence', true),
  url: validator('format', { type: 'url', allowBlank: true }),
});

export default class AudioplayerTrackModel extends Model.extend(Validations) {
  // Attributes
  @attr('string') artist;
  @attr('string') availableFrom;
  @attr('string') name;
  @attr('number', { defaultValue: 0 }) position;
  @attr('string') url;

  // Meta fields
  @attr cmsCreated;
  @attr cmsModified;

  // Relation
  @belongsTo('audioplayer', { async: true, inverse: 'tracks' }) audioplayer;
  @belongsTo('asset', { async: true, inverse: null }) audioFile;
}
